import { CampaignsBase } from './CampaignsBase';
import { Helper } from '../../../common/helpers/Helper';

export class Transactional extends CampaignsBase {
  constructor(props, options) {
    super(props, {
      ...options,
      pageTitle: Helper.getString('transactional'),
      campaignType: 'TRANSACTIONAL',
    });
  }
}
